"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NumberService = /** @class */ (function () {
    function NumberService() {
        this.THOUSAND = 1000;
        this.MILLION = Math.pow(this.THOUSAND, 2);
        this.BILLION = Math.pow(this.THOUSAND, 3);
        this.createPrettyString = function (x, suffix) {
            return "" + Math.floor(x) + suffix;
        };
    }
    NumberService.prototype.toPretty = function (x) {
        if (x >= this.BILLION) {
            return this.createPrettyString(x / this.BILLION, "B" /* BILLION */);
        }
        if (x >= this.MILLION) {
            return this.createPrettyString(x / this.MILLION, "M" /* MILLION */);
        }
        if (x >= this.THOUSAND) {
            return this.createPrettyString(x / this.THOUSAND, "k" /* THOUSAND */);
        }
        return "" + x;
    };
    return NumberService;
}());
exports.NumberService = NumberService;
//# sourceMappingURL=number.js.map